<template>
  <v-container fluid>
    <v-toolbar color="#fafafa" flat>
      <v-btn  icon outline color="black" to="/artistas">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title >Editar </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn dark color="green"  @click="$refs.artist_info_ref.salvar()">salvar</v-btn>
    </v-toolbar>
  <v-divider></v-divider>
    <template>
      
      <artista_info :artist_id="item_id" ref="artist_info_ref"/>
    </template>
  </v-container>
</template>


<script>
import artista_info from "../../components/artistas/artista_info";

export default {
  components: {
    artista_info
  },
  data() {
    return {
      item_id:  this.$route.params.id
    };
  },
  beforeCreated() {
    //this.item_id = this.$route.params.id;
  },
  created() {
    
  },
  mounted() {},
  beforeDestroy() {},
  destroy() {}
};
</script>